<template>
	<a
		href="https://wa.me/31413289694"
		title="Contact via WhatsApp"
		class="cursor:hidden h-20 w-20 rounded-full bg-green-400 flex items-center justify-center shadow-md border border-green-500"
		target="_blank"
	>
		<AtomFontAwesome
			data-testid="AtomWhatsappButton-icon"
			icon="fa-whatsapp"
			library="fab"
			class="w-12 h-12 text-white"
		/>
	</a>
</template>
